<!-- 登录 -->
<template>
  <div class='login account-page page-content'>
    <div class="div-banner">
      <img src="@/assets/imgs/other/accoun-bind-new.png" alt="" class="">
      <div class="div-logo">
        <img src="@/assets/imgs/icon/icon_app_logo.png" class="img-logo" />
        <span class="span-logo">金质花</span>
      </div>
    </div>
    <div class="pad-side20" v-if="!autoPhone">
      <p class="font12">手机号</p>
      <input name="手机号" type="tel" maxlength="11" placeholder="请输入您的手机号" v-model="phoneNo">
      <p class="font12">验证码</p>
      <div class="relative-wrap">
        <input name="验证码" type="text" placeholder="请输入短信验证码" maxlength="6" v-model="verifyCode">
        <GetVerificationCode class="getcode-btn" @sendCode="sendCode" :sensorsInfo="{business_type: '客户服务',current_page: '客户服务'}" :reqData="{phoneNo: phoneNo, type: '14'}" />
      </div>
    </div>
    <div class="btn-wrap flex justify-content-center">
      <input type="button" value="进入客服" class="lg-btn" @click="verify">
    </div>
    <!-- <p class="font12 p-register">
      <span class="span-father">
        <span>还没有账户？<span class="orange-text" @click="navigatePageTo">注册</span></span>
        <span>忘记密码？<span class="orange-text" @click="forgetPwd">找回</span></span>
      </span>
    </p> -->
  </div>
</template>

<script>
import GetVerificationCode from "@/components/GetVerificationCode.vue";
import { checkPhone } from "@/utils/verifyFunc";
import {reqBindWeChat, reqCheckCode, reqJGTokenVerify, reqWxToken} from '@/api';
import JS from 'crypto-js';
import JVerify from '@/utils/jverify'

export default {
  name: 'ConsumerVerify',

  components: {
    GetVerificationCode
  },

  data () {
    return {
      phoneNo: '',
      verifyCode: '',
      hasCode: false,
      // 是否为一键登录
      autoPhone: false,
      operater: '',
      // 一键登录获取到的token
      verifyToken: '',
    };
  },

  created() {
	if (!localStorage.openid) {
	  this.getOpenid();
	}
    this.phoneNo =  localStorage.getItem('phone') || '';
    if (this.phoneNo !== '') {
      this.goCustomerService();
    } else {
      let num = 0;
      let intv = setInterval(() => {
        if (num++ === 10) {
          clearInterval(intv);
          return;
        }
        if (JVerify.isInitial()) {
          clearInterval(intv);
          // 设置一键登录UI样式
          JVerify.setLoginUI();
          this.doLoginAuth();
        }
      }, 500);
    }
  },

  mounted() {
    
  },

  activated() {
    
  },

  methods: {
    // 进行一键登录鉴权
    doLoginAuth() {
      JVerify.loginAuth('CustomerService')
      .then((data) => {
        let {
          content: token,
          operater
        } = data;
        this.operater = operater;
        // 获取到Token，根据Token请求加密手机号
        // this.getEncryptMobile(token);
        if (token && token !== '') {
          this.autoPhone = true;
          this.verifyToken = token;
          this.doDecodePhone();
        }
      }).catch((err) => {
        console.error(err);
      });
    },

    sendCode() {
      this.hasCode = true
    },

    // 登录前判断
    verify() {
      let {phoneNo, verifyCode} = this;
      if(!phoneNo) {
        this.$toast("请输入您的手机号")
        return;
      }
      if(!checkPhone(phoneNo)) {
        this.$toast("请输入正确的手机号")
        return;
      }
      if (!this.hasCode) {
        this.$toast("您未获取验证码")
        return;
      }
      if(!verifyCode) {
        this.$toast("请输入验证码")
        return;
      }
      if(verifyCode.length < 6){
        this.$toast("请输入6位的验证码")
        return;
      }
      this.doLogin();
    },

    doLogin() {
      // 测试
      // this.goCustomerService()
      let _this = this;
      let params = {
        phoneNo: this.phoneNo,
        type: '14',
        code: this.verifyCode,
      }
      
      // 鉴权登录
      reqCheckCode(params).then(res => {
        console.info(res);
        // 成功跳转到客服页面
        _this.goCustomerService();
      }).catch(err => {
        _this.$dialog.alert({
          title: "提示",
          message: err.data.resMessage,
        });
      })
    },

    // 解密手机号
    doDecodePhone() {
      let params = {
        deviceOS: 'H5',
        loginToken: this.verifyToken
      }
      reqJGTokenVerify(params).then(res => {
        this.phoneNo = res.phone;
        // 成功跳转到客服页面
        this.goCustomerService();
      }).catch(err => {
        this.$dialog.alert({
          title: "提示",
          message: err.data.resMessage,
        });
      })
    },

    goCustomerService() {
      // nonce=f2c4e617-425d-4f27-bbd2-7356349ada74
      // timestamp=1637636043703
      // web_token=111213141516@666.cn
      this.bindPhone();
      let nonce = this.getRamNumber();
      let webToken = this.phoneNo;
      let timestamp = new Date().getTime();
      let signStr = `nonce=${nonce}&timestamp=${timestamp}&web_token=${webToken}&0049e57c010c4d378d4fbac659b43ccb`;
      signStr = JS.SHA256(signStr).toString().toUpperCase();
      window.location.href = 'https://jmxcfc.udesk.cn/im_client/?web_plugin_id=156521' + 
                            `&c_phone=${webToken}&nonce=${nonce}&timestamp=${timestamp}&web_token=${webToken}&signature=${signStr}&encryption_algorithm=SHA256`
    },
    
    getRamNumber() {
      let result='';
      for(let i = 0; i < 32; i++){
        result += Math.floor(Math.random() * 16).toString(16);//获取0-15并通过toString转16进制
        if (i === 7 || i === 11 || i === 15 || i === 19) {
          result += '-';
        }
      }
      return result;
    },

	getOpenid() {
	  let code = ''
	  let href = location.href
	  let isDevement = process.env.NODE_ENV === 'development'
	  let appid = isDevement ? 'wx022d0e93def8ffa1' : 'wx5474aa13a019f4f4'
	  // let secret = 'bf5fb5a78d4c850a8394043824a985c3'
	  let secret = '035d7ee8f9939d6913906ea9012281cf'
	  code = this.getUrlCode().code
	  if (!code) {
		location.href =
			`https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(href)}&response_type=code&scope=snsapi_userinfo&state=jmx#wechat_redirect`
	  } else {
		// 获取到code后，请求后端接口,获取openid，完成微信登录
		if (!isDevement) {
		  reqWxToken({code: code}).then(res => {
			console.log(JSON.parse(res))
			let result = JSON.parse(res)
			localStorage.setItem('openid', result.openid)
			this.$store.state.access_token = result.access_token
			this.$store.state.refresh_token = result.refresh_token
		  })
		}
	  }
	},

	getUrlCode() {
	  var url = location.search
	  var theRequest = new Object()
	  if (url.indexOf("?") != -1) {
		var str = url.substr(1)
		var strs = str.split("&")
		for(var i = 0; i < strs.length; i ++) {
		  theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
		}
	  }
	  return theRequest
	},

	bindPhone() {
	  let openid = localStorage.openid
	  let idWXSub = localStorage.idWXSub
	  if (openid) {
		reqBindWeChat({
		  deviceOS: 'H5',
		  phoneNo: this.phoneNo,
		  wxuuid: openid,
		  templateId: idWXSub
		}).then(res => {
		  console.log('reqBindWeChat：'+res)
		}).catch(err => {
		  console.log('reqBindWeChat：'+err)
		})
	  }
	},

  },
}

</script>

<style lang='less' scoped>
  .btn-wrap {
    padding: 47px 0 40px;
  }
  .orange-text {
    color: #E3C194;
  }
  .span-father {
    width: 247px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .p-register {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .page-content {
    position: relative;
  }
  .div-banner {
    position: relative;
    top: -19px;
    margin-bottom: 80px;
    .div-logo {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: absolute;
      bottom: -17px;
      .img-logo {
        width: 70px;
        height: 70px;
        margin-bottom: 11px;
      }
      .span-logo {
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 600;
        line-height: 30px;
        color: #2C2B2C;
      }
    }
  }
</style>